import React, { useState, Component } from 'react';
import { Eye, X, FileText, Download, ExternalLink, DollarSign, FileText as FileTextIcon, Percent, Calendar, Plus, ArrowRight, ArrowLeft, Check, Book, ChevronRight, Filter, Search } from 'lucide-react';
const mockRoyalties = [{
  id: 1,
  bookTitle: 'The Garden Among Clouds',
  bookCover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp',
  percentageCeded: 30,
  totalRevenue: '€2,450',
  lastMonthRevenue: '€180',
  contractDate: '15/03/2023',
  nextPayment: '15/01/2024'
}, {
  id: 2,
  bookTitle: 'Love & Lies',
  bookCover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp',
  percentageCeded: 25,
  totalRevenue: '€1,890',
  lastMonthRevenue: '€95',
  contractDate: '22/01/2023',
  nextPayment: '22/01/2024'
}, {
  id: 3,
  bookTitle: 'The Mist Forest',
  bookCover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
  percentageCeded: 40,
  totalRevenue: '€3,200',
  lastMonthRevenue: '€220',
  contractDate: '08/09/2022',
  nextPayment: '08/01/2024'
}];
// Mock data for available works
const availableBooks = [{
  id: '1',
  cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp',
  title: 'The Garden Among Clouds',
  genre: 'Novel',
  year: '2023',
  status: 'in-progress'
}, {
  id: '2',
  cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp',
  title: 'Love & Lies',
  genre: 'Novel',
  year: '2022',
  status: 'published'
}, {
  id: '3',
  cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
  title: 'The Mist Forest',
  genre: 'Thriller',
  year: '2021',
  status: 'published'
}, {
  id: '4',
  cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/omrsrDbXdUTTrHR98EvY6a/IMG_0034.webp',
  title: 'My Prayer Diary',
  genre: 'Spiritual',
  year: '2020',
  status: 'published'
}, {
  id: '5',
  cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mH3hvE4SdWb6hacSUtkerR/IMG_0029.webp',
  title: 'Think Like A Boss',
  genre: 'Self-development',
  year: '2021',
  status: 'unpublished'
}, {
  id: '6',
  cover: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
  title: 'The Silent Echo',
  genre: 'Fiction',
  year: '2019',
  status: 'in-transfer'
}];
// Contract template
const contractTemplate = `COPYRIGHT ASSIGNMENT AGREEMENT
Between:
- [AUTHOR NAME], residing at [ADDRESS], [CITY] ("Author")
- [ASSIGNEE NAME], with registered office at [ADDRESS], [CITY] ("Assignee")
WHEREAS:
- The Author is the exclusive owner of the copyright to the work entitled "[WORK TITLE]"
- The Assignee intends to acquire the economic exploitation rights of the Work
IT IS AGREED AS FOLLOWS:
1. SUBJECT OF THE AGREEMENT
The Author assigns to the Assignee, who accepts, [PERCENTAGE]% of the economic exploitation rights of the Work for a duration of [DURATION] years.
2. ASSIGNED RIGHTS
The assigned rights include, but are not limited to:
- Right of reproduction in any form and manner
- Right of publication and distribution
- Right of translation into other languages
- Right of adaptation for other media
3. COMPENSATION
The Assignee will pay the Author:
- An amount of € [AMOUNT] upon signing this agreement
- Royalties equal to [ROYALTIES_PERCENTAGE]% of the cover price for each copy sold
4. MINIMUM INVESTMENT
The minimum investment for the acquisition of a share of rights is set at [MINIMUM_INVESTMENT]% of the total assigned rights, corresponding to € [MINIMUM_AMOUNT].
5. DURATION AND TERRITORY
This agreement has a duration of [DURATION] years from the date of signing and applies to the territory of [TERRITORY].
6. REPORTING
The Assignee will provide the Author with a quarterly sales report and will proceed with royalty payments within 60 days from the end of each quarter.
7. JURISDICTION
For any dispute arising from this agreement, the Court of [COURT] shall have jurisdiction.
Place and date: [PLACE], [DATE]
The Author                                                   The Assignee
_________________                                 _________________`;
export function RoyaltyManagementPage() {
  const [selectedContract, setSelectedContract] = useState(null);
  const [isContractModalOpen, setIsContractModalOpen] = useState(false);
  const [isNewCampaignModalOpen, setIsNewCampaignModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  // Form data state
  const [formData, setFormData] = useState({
    selectedBook: null,
    percentageCeded: 30,
    totalPrice: 15000,
    minInvestment: 0.5,
    duration: 5,
    territory: 'Italy',
    royaltiesPercentage: 10,
    foro: 'Milan'
  });
  // Function to handle "Manage" button click
  const handleManageRoyalty = royalty => {
    // Find the book corresponding to the royalty
    const bookForRoyalty = availableBooks.find(book => book.title === royalty.bookTitle);
    // Set form data with the selected royalty values
    setFormData({
      selectedBook: bookForRoyalty || null,
      percentageCeded: royalty.percentageCeded,
      totalPrice: parseInt(royalty.totalRevenue.replace('€', '').replace(',', '')),
      minInvestment: 0.5,
      duration: 5,
      territory: 'Italy',
      royaltiesPercentage: 10,
      foro: 'Milan'
    });
    // Set directly to the second step and open the modal
    setCurrentStep(2);
    setIsNewCampaignModalOpen(true);
  };
  const openContractModal = royalty => {
    setSelectedContract(royalty);
    setIsContractModalOpen(true);
  };
  const closeContractModal = () => {
    setSelectedContract(null);
    setIsContractModalOpen(false);
  };
  const openNewCampaignModal = () => {
    setIsNewCampaignModalOpen(true);
    setCurrentStep(1);
    setFormData({
      selectedBook: null,
      percentageCeded: 30,
      totalPrice: 15000,
      minInvestment: 0.5,
      duration: 5,
      territory: 'Italy',
      royaltiesPercentage: 10,
      foro: 'Milan'
    });
  };
  const closeNewCampaignModal = () => {
    setIsNewCampaignModalOpen(false);
  };
  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };
  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };
  const handleBookSelect = book => {
    setFormData({
      ...formData,
      selectedBook: book
    });
  };
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = () => {
    // In a real app, you would send the form to the backend
    alert('Campaign created successfully!');
    closeNewCampaignModal();
  };
  // Filter books based on search
  const filteredBooks = availableBooks.filter(book => book.title.toLowerCase().includes(searchQuery.toLowerCase()) || book.genre.toLowerCase().includes(searchQuery.toLowerCase()));
  // Generate contract with entered data
  const generateContract = () => {
    if (!formData.selectedBook) return contractTemplate;
    let contract = contractTemplate;
    contract = contract.replace('[WORK TITLE]', formData.selectedBook.title);
    contract = contract.replace('[PERCENTAGE]', formData.percentageCeded);
    contract = contract.replace('[DURATION]', formData.duration);
    contract = contract.replace('[AMOUNT]', formData.totalPrice.toLocaleString('it-IT'));
    contract = contract.replace('[ROYALTIES_PERCENTAGE]', formData.royaltiesPercentage);
    contract = contract.replace('[MINIMUM_INVESTMENT]', formData.minInvestment);
    contract = contract.replace('[MINIMUM_AMOUNT]', (formData.totalPrice * (formData.minInvestment / 100)).toLocaleString('it-IT'));
    contract = contract.replace('[TERRITORY]', formData.territory);
    contract = contract.replace('[COURT]', formData.foro);
    contract = contract.replace('[DATE]', new Date().toLocaleDateString('it-IT'));
    return contract;
  };
  return <div className="w-full bg-gray-50 min-h-screen" data-id="element-1385">
      {/* Header */}
      <div className="mb-6" data-id="element-1386">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1387">
          <div data-id="element-1388">
            <h1 className="text-2xl md:text-3xl font-bold text-[#164149]" data-id="element-1389">
              Royalty Management
            </h1>
          </div>
          <button onClick={openNewCampaignModal} className="px-4 py-2 bg-[#C6D6AB] text-gray-800 rounded-md hover:bg-[#b8c99a] transition-colors flex items-center justify-center" data-id="element-1390">
            <Plus size={16} className="mr-2" data-id="element-1391" />
            New Campaign
          </button>
        </div>
      </div>
      {/* KPI Widgets */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-6" data-id="element-1392">
        <KpiWidget title="Total Revenue" value="€7,540" data-id="element-1393" />
        <KpiWidget title="Active Contracts" value="3" data-id="element-1394" />
        <KpiWidget title="Average Royalty" value="31.7%" data-id="element-1395" />
        <KpiWidget title="This Month Revenue" value="€495" data-id="element-1396" />
      </div>
      {/* Royalties List */}
      <div className="space-y-4" data-id="element-1397">
        {mockRoyalties.map(royalty => <div key={royalty.id} className="bg-white rounded-lg border border-gray-200/70 overflow-hidden" data-id="element-1398">
            {/* Header section with border bottom */}
            <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-100" data-id="element-1399">
              <h3 className="text-base font-semibold text-[#164149]" data-id="element-1400">
                {royalty.bookTitle}
              </h3>
              <div className="text-sm text-gray-500" data-id="element-1401">
                Contract from {royalty.contractDate}
              </div>
            </div>
            {/* Content section */}
            <div className="px-4 sm:px-6 py-5" data-id="element-1402">
              <div className="flex flex-col sm:flex-row gap-5" data-id="element-1403">
                {/* Book Cover */}
                <div className="w-[90px] h-[140px] flex-shrink-0 shadow-sm rounded-md overflow-hidden" data-id="element-1404">
                  <img src={royalty.bookCover} alt={royalty.bookTitle} className="w-full h-full object-cover" data-id="element-1405" />
                </div>
                {/* Book Details */}
                <div className="flex-1 min-w-0" data-id="element-1406">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-5" data-id="element-1407">
                    <div className="p-3 bg-white rounded-md border border-gray-200" data-id="element-1408">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-1409">Assigned</div>
                      <div className="text-base font-medium text-gray-900" data-id="element-1410">
                        {royalty.percentageCeded}%
                      </div>
                    </div>
                    <div className="p-3 bg-white rounded-md border border-gray-200" data-id="element-1411">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-1412">Total</div>
                      <div className="text-base font-medium text-gray-900" data-id="element-1413">
                        {royalty.totalRevenue}
                      </div>
                    </div>
                    <div className="p-3 bg-white rounded-md border border-gray-200" data-id="element-1414">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-1415">
                        Last Month
                      </div>
                      <div className="text-base font-medium text-gray-900" data-id="element-1416">
                        {royalty.lastMonthRevenue}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row items-center gap-3" data-id="element-1417">
                    <button onClick={() => handleManageRoyalty(royalty)} className="px-4 py-2 bg-[#C6D6AB] text-gray-800 rounded-md text-sm font-medium hover:bg-[#b8c99a] transition-colors" data-id="element-1418">
                      Manage
                    </button>
                    <button onClick={() => openContractModal(royalty)} className="px-4 py-2 bg-white border border-gray-200 text-gray-600 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors flex items-center" data-id="element-1419">
                      <Eye size={14} className="mr-2" data-id="element-1420" />
                      Contract
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
      </div>
      {/* Contract Modal */}
      {isContractModalOpen && selectedContract && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1421">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-1422">
            <div className="p-6" data-id="element-1423">
              <div className="flex items-center justify-between mb-6" data-id="element-1424">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-1425">
                  Assignment Contract
                </h2>
                <button onClick={closeContractModal} className="text-gray-400 hover:text-gray-600" data-id="element-1426">
                  <X size={24} data-id="element-1427" />
                </button>
              </div>
              <div className="mb-6" data-id="element-1428">
                <div className="flex items-center mb-4" data-id="element-1429">
                  <img src={selectedContract.bookCover} alt={selectedContract.bookTitle} className="w-16 h-24 object-cover rounded-md border border-gray-200 mr-4" data-id="element-1430" />
                  <div data-id="element-1431">
                    <h3 className="text-lg font-semibold text-[#164149]" data-id="element-1432">
                      {selectedContract.bookTitle}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-1433">
                      Contract signed on {selectedContract.contractDate}
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-4 mb-6" data-id="element-1434">
                <div className="grid grid-cols-2 gap-4" data-id="element-1435">
                  <div data-id="element-1436">
                    <h4 className="text-sm font-medium text-gray-700 mb-1" data-id="element-1437">
                      Assigned Percentage
                    </h4>
                    <p className="text-lg font-semibold text-gray-900" data-id="element-1438">
                      {selectedContract.percentageCeded}%
                    </p>
                  </div>
                  <div data-id="element-1439">
                    <h4 className="text-sm font-medium text-gray-700 mb-1" data-id="element-1440">
                      Total Revenue
                    </h4>
                    <p className="text-lg font-semibold text-gray-900" data-id="element-1441">
                      {selectedContract.totalRevenue}
                    </p>
                  </div>
                  <div data-id="element-1442">
                    <h4 className="text-sm font-medium text-gray-700 mb-1" data-id="element-1443">
                      Last Month
                    </h4>
                    <p className="text-lg font-semibold text-gray-900" data-id="element-1444">
                      {selectedContract.lastMonthRevenue}
                    </p>
                  </div>
                  <div data-id="element-1445">
                    <h4 className="text-sm font-medium text-gray-700 mb-1" data-id="element-1446">
                      Next Payment
                    </h4>
                    <p className="text-lg font-semibold text-gray-900" data-id="element-1447">
                      {selectedContract.nextPayment}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4 mb-6" data-id="element-1448">
                <div className="flex items-center justify-between mb-3" data-id="element-1449">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-1450">
                    Contract Document
                  </h4>
                  <button className="flex items-center text-blue-600 hover:text-blue-800 text-sm" data-id="element-1451">
                    <Download size={16} className="mr-1" data-id="element-1452" />
                    Download PDF
                  </button>
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-1453">
                  <FileText size={16} className="mr-2" data-id="element-1454" />
                  <span data-id="element-1455">
                    assignment_contract_
                    {selectedContract.bookTitle.replace(/\s+/g, '_').toLowerCase()}
                    .pdf
                  </span>
                </div>
              </div>
              <div className="flex justify-end space-x-3" data-id="element-1456">
                <button onClick={closeContractModal} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-1457">
                  Close
                </button>
                <button className="px-4 py-2 bg-[#161c2d] text-white rounded-md hover:bg-[#1e2740] transition-colors" data-id="element-1458">
                  <ExternalLink size={16} className="mr-2" data-id="element-1459" />
                  Open Full Contract
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* New Campaign Modal */}
      {isNewCampaignModalOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1460">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto" data-id="element-1461">
            <div className="p-6" data-id="element-1462">
              <div className="flex items-center justify-between mb-6" data-id="element-1463">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-1464">
                  {currentStep === 1 ? 'New Rights Assignment Campaign' : 'Rights Assignment Management'}
                </h2>
                <button onClick={closeNewCampaignModal} className="text-gray-400 hover:text-gray-600" data-id="element-1465">
                  <X size={24} data-id="element-1466" />
                </button>
              </div>
              {/* Progress Steps - Conditional rendering based on whether we're in "Manage" mode or "New Campaign" mode */}
              <div className="mb-8" data-id="element-1467">
                {currentStep === 1 ?
            // Full 3-step progress bar for "New Campaign"
            <div className="flex items-center justify-between" data-id="element-1468">
                    <div className="flex items-center" data-id="element-1469">
                      <div className={`flex items-center justify-center w-7 h-7 rounded-full ${currentStep >= 1 ? 'bg-[#161c2d] text-white' : 'bg-gray-200 text-gray-600'} text-sm`} data-id="element-1470">
                        1
                      </div>
                      <div className="ml-1.5 text-xs font-medium text-gray-900" data-id="element-1471">
                        Work Selection
                      </div>
                    </div>
                    <div className="w-16 h-0.5 bg-gray-200 mx-0" data-id="element-1472">
                      <div className={`h-full ${currentStep >= 2 ? 'bg-[#161c2d]' : 'bg-gray-200'}`} data-id="element-1473"></div>
                    </div>
                    <div className="flex items-center" data-id="element-1474">
                      <div className={`flex items-center justify-center w-7 h-7 rounded-full ${currentStep >= 2 ? 'bg-[#161c2d] text-white' : 'bg-gray-200 text-gray-600'} text-sm`} data-id="element-1475">
                        2
                      </div>
                      <div className="ml-1.5 text-xs font-medium text-gray-900" data-id="element-1476">
                        Assignment Details
                      </div>
                    </div>
                    <div className="w-16 h-0.5 bg-gray-200 mx-0" data-id="element-1477">
                      <div className={`h-full ${currentStep >= 3 ? 'bg-[#161c2d]' : 'bg-gray-200'}`} data-id="element-1478"></div>
                    </div>
                    <div className="flex items-center" data-id="element-1479">
                      <div className={`flex items-center justify-center w-7 h-7 rounded-full ${currentStep >= 3 ? 'bg-[#161c2d] text-white' : 'bg-gray-200 text-gray-600'} text-sm`} data-id="element-1480">
                        3
                      </div>
                      <div className="ml-1.5 text-xs font-medium text-gray-900" data-id="element-1481">
                        Review
                      </div>
                    </div>
                  </div> :
            // 2-step progress bar for "Manage" mode
            <div className="flex items-center justify-center" data-id="element-1482">
                    <div className="flex items-center" data-id="element-1483">
                      <div className={`flex items-center justify-center w-7 h-7 rounded-full ${currentStep === 2 ? 'bg-[#161c2d] text-white' : 'bg-gray-200 text-gray-600'} text-sm`} data-id="element-1484">
                        1
                      </div>
                      <div className="ml-1.5 text-xs font-medium text-gray-900" data-id="element-1485">
                        Assignment Details
                      </div>
                    </div>
                    <div className="w-16 h-0.5 bg-gray-200 mx-4" data-id="element-1486">
                      <div className={`h-full ${currentStep === 3 ? 'bg-[#161c2d]' : 'bg-gray-200'}`} data-id="element-1487"></div>
                    </div>
                    <div className="flex items-center" data-id="element-1488">
                      <div className={`flex items-center justify-center w-7 h-7 rounded-full ${currentStep === 3 ? 'bg-[#161c2d] text-white' : 'bg-gray-200 text-gray-600'} text-sm`} data-id="element-1489">
                        2
                      </div>
                      <div className="ml-1.5 text-xs font-medium text-gray-900" data-id="element-1490">
                        Review
                      </div>
                    </div>
                  </div>}
              </div>
              {/* Step 1: Work Selection */}
              {currentStep === 1 && <div data-id="element-1491">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1492">
                    Select a Work
                  </h3>
                  {/* Search bar */}
                  <div className="mb-6" data-id="element-1493">
                    <div className="relative" data-id="element-1494">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1495">
                        <Search size={18} className="text-gray-400" data-id="element-1496" />
                      </div>
                      <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Search works..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1497" />
                    </div>
                  </div>
                  {/* Books grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6" data-id="element-1498">
                    {filteredBooks.map(book => <div key={book.id} className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${formData.selectedBook?.id === book.id ? 'border-[#161c2d] ring-2 ring-[#161c2d]/20' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => handleBookSelect(book)} data-id="element-1499">
                        <div className="flex p-3" data-id="element-1500">
                          <div className="w-16 h-24 flex-shrink-0" data-id="element-1501">
                            <img src={book.cover} alt={book.title} className="w-full h-full object-cover rounded-sm" data-id="element-1502" />
                          </div>
                          <div className="ml-3 flex-1" data-id="element-1503">
                            <h4 className="text-sm font-medium text-gray-900 line-clamp-2" data-id="element-1504">
                              {book.title}
                            </h4>
                            <div className="flex items-center mt-1" data-id="element-1505">
                              <span className="text-xs text-gray-500" data-id="element-1506">
                                {book.genre}
                              </span>
                              <span className="mx-1 text-gray-300" data-id="element-1507">•</span>
                              <span className="text-xs text-gray-500" data-id="element-1508">
                                {book.year}
                              </span>
                            </div>
                            <div className="mt-2" data-id="element-1509">
                              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${book.status === 'published' ? 'bg-green-100 text-green-800' : book.status === 'in-progress' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1510">
                                {book.status === 'published' ? 'Published' : book.status === 'in-progress' ? 'In Progress' : 'Unpublished'}
                              </span>
                            </div>
                          </div>
                          {formData.selectedBook?.id === book.id && <div className="flex items-start" data-id="element-1511">
                              <div className="w-5 h-5 bg-[#161c2d] rounded-full flex items-center justify-center" data-id="element-1512">
                                <Check size={12} className="text-white" data-id="element-1513" />
                              </div>
                            </div>}
                        </div>
                      </div>)}
                  </div>
                  {filteredBooks.length === 0 && <div className="text-center py-8" data-id="element-1514">
                      <Filter size={48} className="mx-auto text-gray-400 mb-4" data-id="element-1515" />
                      <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1516">
                        No works found
                      </h3>
                      <p className="text-gray-600" data-id="element-1517">
                        Try modifying your search terms.
                      </p>
                    </div>}
                </div>}
              {/* Step 2: Assignment Details */}
              {currentStep === 2 && <div data-id="element-1518">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1519">
                    Assignment Details
                  </h3>
                  {formData.selectedBook && <div className="flex items-center mb-6 p-3 bg-gray-50 rounded-lg" data-id="element-1520">
                      <img src={formData.selectedBook.cover} alt={formData.selectedBook.title} className="w-12 h-18 object-cover rounded-sm mr-3" data-id="element-1521" />
                      <div data-id="element-1522">
                        <h4 className="font-medium text-gray-900" data-id="element-1523">
                          {formData.selectedBook.title}
                        </h4>
                        <div className="text-sm text-gray-500" data-id="element-1524">
                          {formData.selectedBook.genre} •{' '}
                          {formData.selectedBook.year}
                        </div>
                      </div>
                    </div>}
                  <div className="space-y-4 mb-6" data-id="element-1525">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1526">
                      <div data-id="element-1527">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1528">
                          Assigned Rights Percentage (%)
                        </label>
                        <input type="number" name="percentageCeded" value={formData.percentageCeded} onChange={handleInputChange} min="1" max="100" className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1529" />
                      </div>
                      <div data-id="element-1530">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1531">
                          Total Price (€)
                        </label>
                        <input type="number" name="totalPrice" value={formData.totalPrice} onChange={handleInputChange} min="1" className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1532" />
                      </div>
                      <div data-id="element-1533">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1534">
                          Minimum Investment (%)
                        </label>
                        <input type="number" name="minInvestment" value={formData.minInvestment} onChange={handleInputChange} min="0.1" max="100" step="0.1" className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1535" />
                        <p className="text-xs text-gray-500 mt-1" data-id="element-1536">
                          Equivalent to €
                          {(formData.totalPrice * (formData.minInvestment / 100)).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                        </p>
                      </div>
                      <div data-id="element-1537">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1538">
                          Duration (years)
                        </label>
                        <input type="number" name="duration" value={formData.duration} onChange={handleInputChange} min="1" className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1539" />
                      </div>
                      <div data-id="element-1540">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1541">
                          Territory
                        </label>
                        <input type="text" name="territory" value={formData.territory} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1542" />
                      </div>
                      <div data-id="element-1543">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1544">
                          Royalties Percentage (%)
                        </label>
                        <input type="number" name="royaltiesPercentage" value={formData.royaltiesPercentage} onChange={handleInputChange} min="0" max="100" className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1545" />
                      </div>
                      <div data-id="element-1546">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1547">
                          Jurisdiction
                        </label>
                        <input type="text" name="foro" value={formData.foro} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#161c2d]/20 focus:border-[#161c2d]" data-id="element-1548" />
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Step 3: Review */}
              {currentStep === 3 && <div data-id="element-1549">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1550">
                    Contract Review
                  </h3>
                  <div className="mb-6" data-id="element-1551">
                    <div className="flex items-center justify-between mb-3" data-id="element-1552">
                      <h4 className="text-sm font-medium text-gray-700" data-id="element-1553">
                        Assignment Summary
                      </h4>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 mb-4" data-id="element-1554">
                      <div className="flex items-center mb-4" data-id="element-1555">
                        {formData.selectedBook && <img src={formData.selectedBook.cover} alt={formData.selectedBook.title} className="w-12 h-18 object-cover rounded-sm mr-3" data-id="element-1556" />}
                        <div data-id="element-1557">
                          <h4 className="font-medium text-[#164149]" data-id="element-1558">
                            {formData.selectedBook ? formData.selectedBook.title : 'No work selected'}
                          </h4>
                          {formData.selectedBook && <div className="text-sm text-gray-500" data-id="element-1559">
                              {formData.selectedBook.genre} •{' '}
                              {formData.selectedBook.year}
                            </div>}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-1560">
                        <div data-id="element-1561">
                          <div className="text-xs text-gray-500" data-id="element-1562">
                            Assigned Percentage
                          </div>
                          <div className="text-sm font-medium" data-id="element-1563">
                            {formData.percentageCeded}%
                          </div>
                        </div>
                        <div data-id="element-1564">
                          <div className="text-xs text-gray-500" data-id="element-1565">
                            Total Price
                          </div>
                          <div className="text-sm font-medium" data-id="element-1566">
                            €{formData.totalPrice.toLocaleString('it-IT')}
                          </div>
                        </div>
                        <div data-id="element-1567">
                          <div className="text-xs text-gray-500" data-id="element-1568">
                            Minimum Investment
                          </div>
                          <div className="text-sm font-medium" data-id="element-1569">
                            {formData.minInvestment}%
                          </div>
                        </div>
                        <div data-id="element-1570">
                          <div className="text-xs text-gray-500" data-id="element-1571">Duration</div>
                          <div className="text-sm font-medium" data-id="element-1572">
                            {formData.duration} years
                          </div>
                        </div>
                        <div data-id="element-1573">
                          <div className="text-xs text-gray-500" data-id="element-1574">Territory</div>
                          <div className="text-sm font-medium" data-id="element-1575">
                            {formData.territory}
                          </div>
                        </div>
                        <div data-id="element-1576">
                          <div className="text-xs text-gray-500" data-id="element-1577">Royalties</div>
                          <div className="text-sm font-medium" data-id="element-1578">
                            {formData.royaltiesPercentage}%
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4" data-id="element-1579">
                      <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-1580">
                        Contract Preview
                      </h4>
                      <div className="bg-white border border-gray-200 rounded-md p-4 h-64 overflow-y-auto whitespace-pre-wrap text-sm font-mono" data-id="element-1581">
                        {generateContract()}
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Navigation Buttons */}
              <div className="flex justify-between pt-4 border-t border-gray-200" data-id="element-1582">
                {currentStep > 1 ? <button onClick={prevStep} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors flex items-center" data-id="element-1583">
                    <ArrowLeft size={16} className="mr-2" data-id="element-1584" />
                    Back
                  </button> : <button onClick={closeNewCampaignModal} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-1585">
                    Cancel
                  </button>}
                {currentStep < 3 ? <button onClick={nextStep} disabled={currentStep === 1 && !formData.selectedBook} className={`px-4 py-2 rounded-md transition-colors flex items-center ${currentStep === 1 && !formData.selectedBook ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-[#C6D6AB] text-gray-800 hover:bg-[#b8c99a]'}`} data-id="element-1586">
                    Next
                    <ArrowRight size={16} className="ml-2" data-id="element-1587" />
                  </button> : <button onClick={handleSubmit} className="px-4 py-2 bg-[#C6D6AB] text-gray-800 rounded-md hover:bg-[#b8c99a] transition-colors flex items-center" data-id="element-1588">
                    Create Campaign
                    <Check size={16} className="ml-2" data-id="element-1589" />
                  </button>}
              </div>
            </div>
          </div>
        </div>}
    </div>;
}
// KPI Widget Component
function KpiWidget({
  title,
  value
}) {
  return <div className="bg-white rounded-lg border border-gray-200/70 p-4" data-id="element-1590">
      <div className="text-sm text-gray-500" data-id="element-1591">{title}</div>
      <div className="text-xl font-medium text-gray-900 mt-1" data-id="element-1592">{value}</div>
    </div>;
}